import { Link as RouterLink, Outlet, To, useLocation, useNavigate } from "react-router-dom";
import Tab, { TabProps } from '@mui/material/Tab';
import { IconButton, Tooltip, Typography } from '@mui/material';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import { TabsStyled } from "./Tabs.styled";
import { useTheme } from "@emotion/react";
import { TicketRoute } from "../../../../models/types";
import ReturnButton from "@shared/ui/navigation/ReturnButton";
import { StyledTickets } from "./Tickets.styled";
import { TicketHebType } from "../../../../models/types";
import { useTicketBrowseUrlParamsCache } from "@features/tickets/shared/hooks";


interface LinkTabProps extends TabProps {
  to: To;
  selected?: boolean
}


function LinkTab(props: LinkTabProps) {

  const { to, selected, ...rest } = props;
  const theme = useTheme();

  return (
    <Tab
      component={RouterLink}
      to={to}
      aria-current={selected ? 'page' : undefined}
      selected={selected}
      {...rest}
      sx={{
        textTransform: 'none',
        fontWeight: 500,
        minHeight: 40,
        paddingInline: '20px',
        paddingBlock: '8px',
        color: '#6b7280',
        backgroundColor: '#e9eaed',
        border: '1px solid #d1d5db',
        borderBottom: 'none',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        transition: 'background-color 0.15s ease, color 0.15s ease',
        '&:hover': {
          backgroundColor: '#f1f2f4',
        },
        '&.Mui-selected': {
          backgroundColor: '#fff',
          color: theme.colors.main_color,
          fontWeight: 700,
          marginBottom: '-2px',
          zIndex: 1,
          boxShadow: '0 -3px 6px rgba(0,0,0,0.05)',
        },
      }}
    />
  );
}

type Tab = {
  label: string,
  type: TicketHebType,
  url: TicketRoute,
}

// Define an array of tab hrefs
const tabsData: Tab[] = [
  {
    label: "לקוחות/ספקים",
    type: "לקוח-ספק",
    url: "customers",
  },
  {
    label: "פריטים/מלאי",
    type: "פריט",
    url: "items",
  },
  {
    label: "קודי עבודה",
    type: "עבודה",
    url: "works",
  },
  {
    label: "רכבים",
    type: "רכב",
    url: "cars",
  },
  {
    label: "הכנסות",
    type: "הכנסה",
    url: "incomes",
  },
  {
    label: "הוצאות",
    type: "הוצאה",
    url: "outcomes",
  },
  {
    label: "בנק",
    type: "בנק",
    url: "banks",
  },
  {
    label: "קופה",
    type: "קופה",
    url: "cash-boxes",
  },
  {
    label: "מערכת",
    type: "מערכת",
    url: "system",
  },

];


function Tickets() {
  
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { getUrlParamsSearch } = useTicketBrowseUrlParamsCache();

  const currentIndex = tabsData.findIndex(tab => `/${tab.url}` === location.pathname);
  const value = currentIndex !== -1 ? currentIndex : 0;



  function addTicket(): void {
    navigate(`${location.pathname}/add`);
    // navigate(`${location.pathname}/add`, {
    //   replace: true,
    //   state: {
    //       breadcrumbData: [
    //           {
    //             name: "כרטסות",
    //           },
    //           {
    //             name: tabsData[currentIndex].label,
    //             link: `/${tabsData[currentIndex].url}`
    //           },
    //           {
    //             name: `הוספת כרטיס`
    //           }
    //       ]
    //   }}
    // );
  }


  return (
    <StyledTickets>
      <Typography variant="h5" component="span">
        דפדוף בכרטסות
      </Typography>

      {/* <button onClick={addTicket}>+ הוספת כרטיס</button> */}
      <Tooltip title={`הוספת כרטיס ${tabsData[value]?.type ?? ""}`}>
        <IconButton onClick={addTicket} sx={{ color: theme.colors.main_color }}>
          <BookmarkAddIcon />
        </IconButton>
      </Tooltip>

      <TabsStyled
        dir='ltr'
        value={value}
        //textColor="secondary"
        //indicatorColor="secondary"
        role="navigation"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        style={{ direction: "rtl", flexDirection: "row-reverse", borderBottom: "none", marginTop: 20 }}

      >
        {tabsData.map((tab, index) => (
          <LinkTab
            key={index}
            label={tab.label}
            to={{
              pathname: `/${tab.url}`,
              search: getUrlParamsSearch(`/${tab.url}`),
            }}
          />
        ))}
      </TabsStyled>
      <Outlet />

      <div className="buttons">
        <ReturnButton/>
      </div>
      
    </StyledTickets>
  );
}

export default Tickets;